module.exports = __webpack_public_path__ + "img/examNull.c1bac841.png";